import styled from "styled-components";

const getButtonStyles = (type) => {
  switch (type) {
    case 'critical':
      return `
        background: linear-gradient(135deg, #dc3545, #c82333);
        border: 1px solid rgb(196, 80, 91);
        color: #FFFFFF;
        
        &:hover {
          background: linear-gradient(135deg, #c82333, #a71e2a);
        }
      `;
    case 'secondary':
      return `
        background: linear-gradient(135deg, #6c757d, #5a6268);
        border: 1px solid #6c757d;
        color: #FFFFFF;
        
        &:hover {
          background: linear-gradient(135deg, #5a6268, #495057);
        }
      `;
    case 'default':
    default:
      return `
        background: rgba(255,255,255,0.1);
        border: 1px solid rgba(255,255,255,0.2);
        color: #FFFFFF;
        
        &:hover {
            background: rgba(255,255,255,0.2);
        }
      `;
  }
};

export const BoxBtnContainer = styled.button`
    border-radius: 4px;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    font-size: 12px;
    font-weight: 600;
    height: 40px;
    width: 40px; /* Fixed width and height for square buttons */
    min-width: 40px; /* Override min-width from PrimaryBtn */
    opacity: ${({ disabled }) => (disabled ? "0.25" : "1.0")};
    transition: 0.3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ $type }) => getButtonStyles($type)}

    &:hover {
        filter: ${({ disabled }) => (disabled ? "none" : "drop-shadow(2px 2px rgba(0,0,0,0.15))")};
        transform: ${({ disabled }) => (disabled ? "none" : "scale(1.015)")};
    }
`;